module.exports = __webpack_public_path__ + "img/pin.ce72e85b.svg";